
interface DatePickerProps {
  label: string;
  value: string;
  onChange: (date: string) => void;
  minDate?: string;
}

export function DatePicker({ label, value, onChange, minDate }: DatePickerProps) {

  const formatDate = (dateStr: string) => {
    if (!dateStr) return 'YYYY-MM-DD';
    return dateStr;
  };

  return (
    <div className="w-full">
      <label className="block text-xs font-mono text-orbital-cyan uppercase tracking-widest mb-3">
        {label} [DATE_SELECT]
      </label>

      <div
        className={`relative bg-orbital-card border transition-all duration-300 ${
          value
            ? 'border-orbital-cyan/50'
            : 'border-orbital-dim hover:border-orbital-dim/70'
        }`}
      >
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          min={minDate}
          className="w-full bg-transparent text-orbital-primary font-mono px-4 py-3 pr-12 focus:outline-none cursor-pointer"
        />
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-orbital-magenta">
          <span className="text-lg">📅</span>
        </div>
      </div>

      {/* Terminal-style hint */}
      <div className="mt-2 flex items-center gap-2 text-xs text-gray-600 font-mono">
        <span className="text-orbital-magenta">&gt;</span>
        <span>
          {value
            ? `SELECTED: ${formatDate(value)}`
            : 'AWAITING DATETIME INPUT...'}
        </span>
      </div>
    </div>
  );
}
